import React, { useContext, useState, useEffect } from "react";
import * as FaIcons from "react-icons/fa";
import RegistrationContext from "../../../context/registration/registrationContext";
//import {useEffect} from 'react';
import ProgressButtons from "../ProgressButtons";

const R10MigrantEducation = () => {
  const registrationContext = useContext(RegistrationContext);

  const {
    formData: {
      firstName,
      isPgEmployedInOneOrMoreAgriculturalOrFishingActivities,
    },
    onFormDataChange,
    pass: { migrantEducation1 },
  } = registrationContext;

  const migrantEdu =
    isPgEmployedInOneOrMoreAgriculturalOrFishingActivities !== "";

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Are you sure you want to leave?";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  return (
    <>
      <div className="sub-form">
        <h2 className="">
          Migrant Education <span>(9/15)</span>
          <hr />
        </h2>
        {!migrantEducation1 && (
          <p className="validation-msg">Please fill the all required details</p>
        )}

        <div className="item">
          <div className="asterisk-group">
            <h3>
              Is {firstName === "" ? "the Student" : firstName}'s
              Parent/Guardian Employed in One or More Agricultural or Fishing
              Activities on a Season or Other Temporary Basis?{" "}
            </h3>
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </div>
          <div
            className="flex-check-container"
            style={{
              border: migrantEducation1
                ? "1px solid #ccc;"
                : isPgEmployedInOneOrMoreAgriculturalOrFishingActivities !== ""
                ? "1px solid #ccc"
                : "#d8302f 2px solid",
            }}
          >
            <label className="check-container">
              Yes
              <input
                type="radio"
                value="yes"
                checked={
                  isPgEmployedInOneOrMoreAgriculturalOrFishingActivities["yes"]
                }
                onChange={(e) => onFormDataChange(e)}
                name="isPgEmployedInOneOrMoreAgriculturalOrFishingActivities"
              />
              <span className="styled-checkmark"></span>
            </label>
            <label className="check-container">
              No
              <input
                type="radio"
                checked={
                  isPgEmployedInOneOrMoreAgriculturalOrFishingActivities["no"]
                }
                onChange={(e) => onFormDataChange(e)}
                name="isPgEmployedInOneOrMoreAgriculturalOrFishingActivities"
              />
              <span className="styled-checkmark"></span>
            </label>
          </div>
        </div>
      </div>
      <ProgressButtons validation={migrantEdu} name="migrantEducation1" />
    </>
  );
};

export default R10MigrantEducation;
